import {Component, OnInit} from '@angular/core';
import {ActivatedRoute, Router, UrlSegment} from '@angular/router';
import {environment} from '../environments/environment';


@Component({
  template: '',
  selector: 'redirect-component',
  imports: []
})
export class RedirectLegacyComponent implements OnInit {
  constructor(private route: ActivatedRoute, private router: Router) {
    console.log('RedirectComponent constructor');
  }

  ngOnInit() {
    let fullSegments: UrlSegment[] = [];

    let current: ActivatedRoute | null = this.route;

    while (current) {
      const segments = current.snapshot.url;
      if (segments.length > 0) {
        fullSegments = [...segments, ...fullSegments];
      }
      current = current.parent;
    }


    const [_, legacyOrg , ...rest] = fullSegments.map(seg => seg.path);
    const urn = environment.redirects[legacyOrg] || null;
    if (!urn) {
      console.error(`No URN mapping found for legacy organization: ${legacyOrg}`);
      this.router.navigateByUrl('/', { replaceUrl: true });

    }
    const newSegments = ['o', urn, ...rest];
    const newUrl = '/' + newSegments.join('/');

    this.router.navigate(newSegments, { replaceUrl: true, queryParams: this.route.snapshot.queryParams, });

  }
}
